import React, { createContext, useContext, useState } from 'react';

type CareerPathType = 'NO_JOB' | 'NEW_JOB' | 'CAREER_TRANSITION' | 'VOCATIONAL_IMPROVEMENT' | null;

interface CareerContextType {
  careerPath: CareerPathType;
  setCareerPath: (path: CareerPathType) => void;
}

const CareerContext = createContext<CareerContextType | undefined>(undefined);

export function CareerProvider({ children }: { children: React.ReactNode }) {
  const [careerPath, setCareerPath] = useState<CareerPathType>(null);

  return (
    <CareerContext.Provider value={{ careerPath, setCareerPath }}>
      {children}
    </CareerContext.Provider>
  );
}

export function useCareerPath() {
  const context = useContext(CareerContext);
  if (context === undefined) {
    throw new Error('useCareerPath must be used within a CareerProvider');
  }
  return context;
}